import bus from './bus'
import filters from './filters'
import directives from './directives'
import axios from './axios'
import moment from './moment'
import lodash from './lodash'
import numeral from './numeral'
import elementUI from './elementUI'
import components from './components'
import store from './store'
import router from './router'
import googleAnalytics from './googleAnalytics'
import asyncExecutor from './asyncExecutor'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/element-io-bootstrap.styl'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@/assets/css/index.styl'

const isProd = process.env.NODE_ENV === 'production'

export default function (app) {
  bus(app)
  axios(app)
  moment(app)
  numeral(app)
  lodash(app)

  filters(app)
  directives(app)
  store(app)
  router(app)

  if (isProd) googleAnalytics(app)

  elementUI()
  components()
  asyncExecutor()

  return 'all init'
}
